import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle, Youtube, Twitter, Linkedin } from "lucide-react";
import Logo from "./Logo";

const SOCIALS = [
  { key: "instagram", label: "Instagram", icon: Instagram, base: "https://instagram.com/" },
  { key: "youtube", label: "YouTube", icon: Youtube, base: "https://youtube.com/@" },
  { key: "twitter", label: "X / Twitter", icon: Twitter, base: "https://x.com/" },
  { key: "linkedin", label: "LinkedIn", icon: Linkedin, base: "https://linkedin.com/in/" },
];

export default function Footer({ settings }) {
  const s = settings || {};
  const socials = s.socials || {};
  const contact = s.contact || {};
  const year = new Date().getFullYear();

  const wa = contact.whatsapp ? contact.whatsapp.replace(/[^0-9+]/g, "") : "";

  return (
    <footer data-testid="site-footer" className="border-t border-line bg-surface">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-4 text-sub text-sm leading-relaxed max-w-xs">
            {s.footer?.note || s.tagline || "Catatan tentang pendidikan, karakter, Jepang, bisnis, dan kehidupan."}
          </p>
          {s.full_name && <p className="mt-3 text-xs text-faint">{s.full_name}</p>}
          <div className="flex gap-2 mt-5">
            {SOCIALS.map(({ key, label, icon: Icon, base }) =>
              socials[key] ? (
                <a
                  key={key}
                  href={socials[key].startsWith("http") ? socials[key] : base + socials[key].replace(/^@/, "")}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${key}`}
                  aria-label={label}
                  className="w-11 h-11 rounded-full border border-line flex items-center justify-center text-sub hover:text-enji hover:border-enji transition-colors"
                >
                  <Icon size={17} />
                </a>
              ) : null
            )}
          </div>
        </div>
        <nav className="md:col-span-3" aria-label="Navigasi footer">
          <p className="text-xs uppercase tracking-[0.18em] font-semibold text-faint mb-4">Jelajahi</p>
          <ul className="space-y-2.5 text-[15px]">
            <li><Link to="/tulisan" className="text-sub hover:text-ink transition-colors">Tulisan</Link></li>
            <li><Link to="/buku-karya" className="text-sub hover:text-ink transition-colors">Buku &amp; Karya</Link></li>
            <li><Link to="/konsultasi" className="text-sub hover:text-ink transition-colors">Konsultasi</Link></li>
            <li><Link to="/newsletter" className="text-sub hover:text-ink transition-colors">Newsletter</Link></li>
            <li><Link to="/tentang" className="text-sub hover:text-ink transition-colors">Tentang Saya</Link></li>
          </ul>
        </nav>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.18em] font-semibold text-faint mb-4">Hubungi</p>
          <ul className="space-y-2.5 text-[15px]">
            {contact.email && (
              <li>
                <a href={`mailto:${contact.email}`} data-testid="footer-contact-email" className="inline-flex items-center gap-2 text-sub hover:text-ink transition-colors">
                  <Mail size={15} /> {contact.email}
                </a>
              </li>
            )}
            {wa && (
              <li>
                <a href={`https://wa.me/${wa.replace("+", "")}`} target="_blank" rel="noopener noreferrer" data-testid="footer-contact-whatsapp" className="inline-flex items-center gap-2 text-sub hover:text-ink transition-colors">
                  <MessageCircle size={15} /> WhatsApp
                </a>
              </li>
            )}
            {contact.address && <li className="text-sub">{contact.address}</li>}
          </ul>
          <Link to="/newsletter" data-testid="footer-newsletter-button" className="btn-primary mt-6 !min-h-[40px] !px-5">
            {s.newsletter_label || "Newsletter"}
          </Link>
        </div>
      </div>
      <div className="border-t border-line">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-[13px] text-faint">
          <p>&copy; {year} Heri Sensei. Seluruh hak cipta.</p>
          <div className="flex gap-5">
            <Link to="/privasi" className="hover:text-ink transition-colors">Privasi</Link>
            <Link to="/ketentuan" className="hover:text-ink transition-colors">Ketentuan</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
